"use client";

import DiscussionsBox from "components/company/v3/boxes/DiscussionsBox";
import useBrazilianIssuer from "components/company/v3/context/hooks/useBrazilianIssuer";
import type { CompanyDiscussionsTabEnum } from "components/company/v3/menu/enums";
import { IAssetType, ISecurityCountry } from "types/graphqlTypes";

interface BrazilianDiscussionsBoxProps {
  tickerSymbol: string;
  tab: CompanyDiscussionsTabEnum;
  onChangeTab: (tab: CompanyDiscussionsTabEnum) => void;
}

export default function BrazilianDiscussionsBox({ tickerSymbol, tab, onChangeTab }: BrazilianDiscussionsBoxProps) {
  const issuer = useBrazilianIssuer();

  return (
    <DiscussionsBox
      tickerSymbol={tickerSymbol}
      issuerId={issuer._id}
      country={ISecurityCountry.Br}
      assetType={IAssetType.BrazilianCompany}
      tab={tab}
      onChangeTab={onChangeTab}
    />
  );
}
